module.exports = "<div class=\"matriculation-number-help-container\">\n    <img class=\"matriculation-number-help-image\"\n         src=\"/qnb/styles/images/common/matriculation_number_detail.jpg\"\n         ng-click=\"openDialog()\"\n         alt=\"{{'quoteandbind.views.mfp-summary.matriculation-number-help.image-alt-text' | translate }}\"\n    />\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/basler/templates/basler-matriculation-number-help.html
// module id = 550
// module chunks = 0